<!--
 * @Descripttion: 
 * @version: 
 * @Author: wangliuyang
 * @Date: 2021-06-07 15:54:25
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-06-27 10:31:10
-->
<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',

    mounted () {
        // 检查登录状态
        this.getLoginStats();
    },

    watch: {
      //监听路由变化
      "$route": {
        handler() {
          if (this.$route) {
            this.getLoginStats()
          }
          return
        },
        immediate: true
      }
    },

    methods: {
      //检查登录状态
      getLoginStats() {
        //手机跳出
        // if(this.$isFe) return;
        //首页和登录等路由 不需要验证登录
        let routeArr = [ '/', '/index', '/indexFe', '/downApp', '/schoolIndex', '/loginCode', '/loginPassword', '/refundProtocol', '/teachersTeam', '/auditList' ]
        if(routeArr.includes(this.$router.currentRoute.path)) return;
        let query = {
          type: 1
        };
        let option = {
          type: "get",
          api: "/user/loginstate",
          query: query
        };
        this.$request(option, res => {
          console.err('data','token 过期则跳转登录')
        });
      },

    },

  }
</script>


// WEBPACK FOOTER //
// src/App.vue